<template>
    <div class="form-item">
        <label class="label-caption">
            {{ item.nmcaption }}
            <span v-if="isObrigatorio" class="required">*</span>
        </label>

        <select
            :value="item.resposta_opcoes || ''"
            @change="onChange"
        >
            <option value="">Selecione...</option>

            <option
                v-for="opcao in opcoes"
                :key="opcao.value"
                :value="opcao.value"
            >
                {{ opcao.label }}
            </option>
        </select>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['update:item']);

const isObrigatorio = computed(() => props.item.ckobrigatorio === 'S');

const opcoes = computed(() => {
    if (!props.item.opcoes) return [];

    return String(props.item.opcoes)
        .split(';')
        .map(opcao => opcao.trim())
        .filter(Boolean)
        .map(opcao => {
            const partes = opcao.split('=');

            if (partes.length === 2) {
                return {
                    value: partes[0].trim(),
                    label: partes[1].trim()
                };
            }

            return {
                value: opcao,
                label: opcao
            };
        });
});

function onChange(event) {
    emit('update:item', {
        ...props.item,
        resposta_opcoes: event.target.value || null
    });
}
</script>

<style scoped>
.required {
    color: #b00020;
    margin-left: 3px;
}
</style>